export const BAR_HEIGHT = 20
export const BAR_RADIUS = 4
export const SMALL_BAR_RADIUS = 2
export const SMALL_BAR_HEIGHT = 10

export const barTheme = {
  grid: {
    line: {
      stroke: '#dddddd',
      strokeWidth: 0,
      strokeDasharray: '4 4',
    },
  },
  axis: {
    ticks: {
      line: {
        strokeWidth: 0,
      },
    },
  },
}
